import axios from "axios"
import download from "downloadjs"
const downloadImg = (url) => {
  return axios.get(url, { responseType: 'blob'}).then(res => {
    download(res.data, "扫码下载.png", "image/png")
  })
}

export {
  downloadImg
}